import { render } from "./UpdateAgent.vue?vue&type=template&id=fe1fdaec&scoped=true"
import script from "./UpdateAgent.vue?vue&type=script&lang=js"
export * from "./UpdateAgent.vue?vue&type=script&lang=js"

import "./UpdateAgent.vue?vue&type=style&index=0&id=fe1fdaec&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe1fdaec"]])

export default __exports__